module.exports = __webpack_public_path__ + "static/media/installation outcome side 1.1ea89531.png";